import React, { useEffect } from 'react';
import { isMobile, isIOS } from 'react-device-detect';

const MobileViewport = () => {
  useEffect(() => {
    // Define setHeight in the outer scope so it can be used in cleanup
    const setHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    const handleOrientation = async () => {
      if (isMobile) {
        if (isIOS) {
          // For iOS devices, we'll use CSS to force portrait mode
          document.documentElement.style.setProperty('--vh', '1vh');
          window.addEventListener('resize', setHeight);
          setHeight();

          // Add a class to the body for iOS-specific styles
          document.body.classList.add('ios-portrait');
        } else if (window.screen.orientation) {
          // For other mobile devices that support the Screen Orientation API
          try {
            await window.screen.orientation.lock('portrait');
          } catch (error) {
            console.log('Orientation lock not supported');
          }
        }
      }
    };

    handleOrientation();

    // Cleanup function
    return () => {
      if (isMobile) {
        if (isIOS) {
          window.removeEventListener('resize', setHeight);
          document.body.classList.remove('ios-portrait');
        } else if (window.screen.orientation) {
          window.screen.orientation.unlock();
        }
      }
    };
  }, []);

  return null;
};

export default MobileViewport; 